// extracted by mini-css-extract-plugin
export default {"titleBlock":"todo-list-title_titleBlock__Xu5Es","editableBox":"todo-list-title_editableBox__csbHt"};